import styled from "styled-components";

import { stylesGlobalDefault } from "global/globalStyle";

export const Container = styled.div`
  width: 100%;
  overflow-y: hidden;
`;

export const Title = styled.h3`
  font-family: ${stylesGlobalDefault.fontFamily};
  font-weight: 700;
  font-size: 18px;
  color: ${stylesGlobalDefault.white};
  margin-right: 12px;
`;

export const ContainerTitleWithNumber = styled.div`
  display: flex;
  align-items: center;
`;

export const ContainerBody = styled.div`
  width: 100% - 48px;
  overflow: hidden;
  padding: 0 24px;
`;

export const ContainerSearch = styled.div`
  width: 60%;
  height: 100px;
  padding-top: 40px;
  padding-left: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerInput = styled.div`
  width: 80%;
  height: 100px;
`;

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px -40px;
  width: 100% - 40px;
  background: ${stylesGlobalDefault.backgroundListItemColor};
  margin-bottom: 4px;
  border-radius: 8px;
  padding: 20px;
  border: 2px solid ${stylesGlobalDefault.backgroundListItemColor};
  cursor: pointer;

  &:hover {
    border: 2px solid ${stylesGlobalDefault.blue};
  }
`;

export const LabelCard = styled.label``;

//List
export const ContainerList = styled.div`
  width: 100%;
  height: 64vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  @media screen and (min-height: 850px) {
    height: 70vh;
  }
`;

export const LoadingContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1500;
  color: black;
`;

export const SkeletonContainer = styled.div`
  height: 55vh;
  overflow: hidden;
`;
